export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8619.bb16a7e9.jpg";